import "./HandleConfirmationPopup.scss";
import { useEffect } from "react";
import ConfirmationPopup from "../../hoc/ConfirmationPopup/ConfirmationPopup";
import Spinner from "../../components/UI/Spinner/Spinner";

interface IHandleConfirmationPopupProps {
  showPopup: boolean;
  onClose: () => void;
  onConfirm: () => void;
  questionText: React.ReactNode;
  confirmText: string;
  denyText?: string;
  loading?: boolean;
  children?: React.ReactNode;
  wide?: boolean;
  leftTopElement?: React.ReactNode;
  useBlueButton?: boolean;
  /**
   * Greys out the confirm button when the popup's own children have to be
   * dealt with first. The global button:disabled rule outranks .red-button,
   * so it goes grey without any extra styling here.
   */
  confirmDisabled?: boolean;
}

function HandleConfirmationPopup(props: IHandleConfirmationPopupProps) {
  const handleConfirm = () => {
    props.onConfirm();
  };

  useEffect(() => {
    if (props.loading === false && props.loading !== undefined) {
      props.onClose();
    }
  }, [props.loading]);

  return (
    <ConfirmationPopup
      showPopup={props.showPopup}
      onClose={props.onClose}
      onConfirm={props.onConfirm}
      loading={props.loading}
      leftTopElement={props.leftTopElement}
      width={props.wide ? "800px" : undefined}
    >
      <div className="general-popup-wrapper">
        <div className="general-popup-form">
          {props.loading !== undefined && props.loading === true ? (
            <>
              <Spinner />
              <h2 className="text-l">Vänligen lämna inte detta fönster</h2>
            </>
          ) : (
            <>
              <div className="general-popup-form__header">
                <h2 className="text-l">{props.questionText}</h2>
              </div>
              {props.children}
              <button
                className={`auto-btn ${
                  props.useBlueButton ? "" : "red-button"
                }`}
                disabled={props.confirmDisabled}
                onClick={handleConfirm}
              >
                {props.confirmText}
              </button>
            </>
          )}
        </div>
      </div>
    </ConfirmationPopup>
  );
}

export default HandleConfirmationPopup;
